import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
class Empty extends Component {
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'empty'} src={require('../../static/images/404@2x.png')} alt=""/>
					<div className={'empty_text'}>
						抱歉，页面找不到了
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Empty